(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.cw-announcement-bar__slide'));

      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;

      this.isAnimating = false;
      this.animationDuration = 500;

      if (
        this.dataset.autoplay === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    showNext() {
      if (this.isAnimating || this.slides.length <= 1) return;

      const oldIndex = this.currentIndex;
      const newIndex = (oldIndex + 1) % this.slides.length;
      const oldSlide = this.slides[oldIndex];
      const newSlide = this.slides[newIndex];

      this.isAnimating = true;

      oldSlide.classList.remove('is-active');
      oldSlide.classList.add('is-leaving');

      newSlide.classList.remove('is-leaving');
      newSlide.classList.add('is-active');

      window.setTimeout(() => {
        oldSlide.classList.remove('is-leaving');
        this.currentIndex = newIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 3000;
      this.autoplayTimer = window.setInterval(() => this.showNext(), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(
        this.querySelectorAll('details.faq-item')
      );

      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
